// Lista de campos sensibles a ofuscar
const sensitiveFields = [
  'authToken', 'accessToken', 'refreshToken', 'password',
  'secret', 'apiKey', 'authorization', 'token', 'auth'
];

export const sanitizeGraphQLQuery = (query: string): string => {
  if (!query) return 'unknown';

  let sanitized = query;

  // Reemplazar cada campo sensible
  sensitiveFields.forEach(field => {
    const regex = new RegExp(field, 'gi');
    sanitized = sanitized.replace(regex, `[FILTERED]`);
  });

  // También ofuscar valores en variables
  sanitized = sanitized.replace(/(=\s*)"[^"]*"/g, '$1"[FILTERED_VALUE]"');

  return sanitized;
}

export const sanitizeGraphQLVariables = (variables: any): any => {
  if (!variables || typeof variables !== 'object') return variables;

  const isSensitive = (key: string) =>
    sensitiveFields.some(field => key.toLowerCase().includes(field.toLowerCase()));

  const isSensitiveValue = (value: any) =>
    typeof value === 'string' &&
    sensitiveFields.some(field => value.toLowerCase().includes(field.toLowerCase()));

  const sanitize = (obj: any): any => {
    if (Array.isArray(obj)) {
      return obj.map(sanitize);
    }
    if (obj && typeof obj === 'object') {
      return Object.fromEntries(
        Object.entries(obj).map(([key, value]) => {
          if (isSensitive(key) || isSensitiveValue(value)) {
            return [key, '[FILTERED]'];
          }
          return [key, sanitize(value)];
        })
      );
    }
    return obj;
  };

  return sanitize(variables);
};